import React, { useState } from "react";
import { ClockIcon } from '@heroicons/react/24/outline';

const TimeInput = ({ value, setValue, compareValue = null, setError = () => {}, widthClass = 'w-32', disabled = false }) => {
    const [internal, setInternal] = useState('');

    const handleChange = (e) => {
        let inputValue = e.target.value.replace(/\D/g, '').slice(0, 4);
        let formatted = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");

        if (inputValue.length <= 2 && e.target.value.length < formatted.length) {
            formatted = formatted.replace(":", "");
        }

        const hours = parseInt(inputValue.slice(0, 2), 10);
        const minutes = parseInt(inputValue.slice(2), 10);
        if (hours > 24 || (hours === 24 && minutes > 0)) return;

        setValue(formatted);

        if (compareValue && formatted >= compareValue) {
            setError("L'orario di inizio deve essere precedente all'orario di fine.");
        } else {
            setError('');
        }
    };

    const handleBlur = () => {
        if (!value || value.trim() === '') {
            setValue('');
            return;
        }

        let val = value.replace(/\D/g, '').padEnd(4, '0').slice(0, 4);
        const hours = parseInt(val.slice(0, 2), 10);
        const minutes = parseInt(val.slice(2), 10);

        if (hours > 24 || (hours === 24 && minutes > 0)) {
            setValue('');
            return;
        }

        const formatted = `${val.slice(0, 2)}:${val.slice(2)}`;
        const isValid = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formatted);
        setValue(isValid ? formatted : '');
    };

    return (
        <div
            className={`border ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'border-gray-100'} rounded-md`}
            style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}
        >
            <input
                type="text"
                placeholder="hh:mm"
                value={value}
                disabled={disabled}
                onInput={handleChange}
                onBlur={handleBlur}
                className={`p-1 pl-4 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm ${widthClass} ${disabled ? 'text-gray-400' : ''}`}
                style={{ paddingRight: '2.5rem' }}
            />
            <span
                    style={{
                    position: 'absolute',
                    top: '50%',
                    right: '8px',
                    transform: 'translateY(-50%)',
                }}
            >
                <ClockIcon className={`w-4 h-4 ${disabled ? 'text-gray-300' : ''}`} />
            </span>
        </div>
    );
};

export default TimeInput;